import graphqlClient from '@/graphql/graphql-client';
import { toScalarListVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  OrgContractDocumentEventsDocument,
  type OrgContractDocumentEventsQuery,
} from '@/graphql/generated/graphql';

export type ContractDocumentEventItem = NonNullable<
  NonNullable<OrgContractDocumentEventsQuery['getOrgContractDocumentEvents']>['items']
>[number];
export type GetOrgContractDocumentEventsResponse = OrgContractDocumentEventsQuery;

export const useGetOrgContractDocumentEvents = (
  params?: ListQueryVariables<Record<string, unknown>>,
  options?: { enabled?: boolean }
) => {
  const variables = toScalarListVariables(params, { contractDocumentId: 'ContractDocumentId' });
  return useQuery({
    queryKey: ['org-contract-document-events', variables],
    queryFn: () => graphqlClient.request(OrgContractDocumentEventsDocument, variables),
    enabled: options?.enabled ?? true,
  });
};

export const requestOrgContractDocumentEvents = (
  params?: ListQueryVariables<Record<string, unknown>>
) => {
  const variables = toScalarListVariables(params, { contractDocumentId: 'ContractDocumentId' });
  return graphqlClient.request(OrgContractDocumentEventsDocument, variables);
};

export const GET_ORG_CONTRACT_DOCUMENT_EVENTS_QUERY = OrgContractDocumentEventsDocument;
